import React from 'react';
import { useTranslation } from 'react-i18next';

import { APP_VERSION } from '../../config/appVersion';
import type { FooterTheme } from './footerTheme';

interface FooterCopyrightBandProps {
  theme?: FooterTheme;
}

/** Wrangle-style full-width meta band between link footer and oversized wordmark. */
const FooterCopyrightBand: React.FC<FooterCopyrightBandProps> = ({ theme = 'home' }) => {
  const { t } = useTranslation();

  return (
    <div className="marketing-footer-copyright" data-footer-theme={theme}>
      <div className="marketing-footer-copyright__inner">
        <p className="marketing-footer-copyright__text">
          © 2025{' '}
          <a
            href="https://www.zykestech.com"
            target="_blank"
            rel="noopener noreferrer"
            className="marketing-footer-copyright__link"
          >
            Zykes Technologies LLP
          </a>{' '}
          <span className="marketing-footer-copyright__muted">(LLPIN: ACP-5076).</span>{' '}
          {t('footer.allRightsReserved')}
        </p>

        <div className="marketing-footer-copyright__aside">
          <span className="marketing-footer-copyright__version">v{APP_VERSION}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FooterCopyrightBand);
